export default "__VITE_ASSET__2ae5e903__"